import PropTypes from 'prop-types';

import styles from './_index.module.scss';

const DiffBox = ({ value }) => {
  if (!value) return null;
  const isPositive = value > 0;
  return (
    <span className={isPositive ? styles['diff-box-positive'] : styles['diff-box-negative']}>
      {isPositive ? `+${value}` : value}
    </span>
  );
};

DiffBox.propTypes = {
  value: PropTypes.number,
};

export default DiffBox;
